export default {
      id: "woman-usage",
      viewBox: "0 0 18 35",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#woman",
      toString: function () {
        return this.url;
      }
    }